import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { APP_ROUTES } from './app.routes';
import { angularZoneInterceptor } from './core/interceptors/angular-zone.interceptor';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { requestTimeoutInterceptor } from './core/interceptors/request-timeout.interceptor';
import { MaterialModule } from './core/material.module';
import { PwaInstallService } from './services/pwa-install.service';

export const appConfig: ApplicationConfig = {
   providers: [
      provideBrowserGlobalErrorListeners(),
      provideAppInitializer(() => {
         inject(PwaInstallService).start();
      }),
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideAnimationsAsync(),
      provideHttpClient(withInterceptors([requestTimeoutInterceptor, angularZoneInterceptor, authInterceptor])),
      provideRouter(
         APP_ROUTES,
         withInMemoryScrolling({
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
         }),
         withComponentInputBinding(),
      ),
      importProvidersFrom(TablerIconsModule.pick(TablerIcons), FormsModule, ReactiveFormsModule, MaterialModule),
   ],
};
